import { HandlerEvent } from 'post-robot';
import { resetUserProfile, saveFlow } from 'communicator/store';
import { getAccessToken, getIsVisaSRCi, getLaunchData } from 'communicator/store/selectors';
import unbind from 'communicator/utils/unbind';
import { CheckoutLaunchData } from 'types/visa-sdk/checkout';

type SignoutMessageData = {
  data: { idToken: string; isDCF?: boolean };
  closeCheckoutWindow?(): void;
  launchSRCi?(launchData: CheckoutLaunchData): void;
};

export default function signOut(event: HandlerEvent<SignoutMessageData>) {
  const { closeCheckoutWindow, data, launchSRCi } = event.data;

  // In Visa SRCi, VSB SDK will call unbindAppInstance following signout
  if (getIsVisaSRCi()) {
    saveFlow({
      dcfActionCode: 'SWITCH_CONSUMER',
      toRoute: 'identity'
    });

    launchSRCi?.(getLaunchData());

    if (!data.isDCF) {
      unbind({
        accessToken: getAccessToken()?.token,
        idTokens: [data.idToken]
      });
    }
  } else {
    unbind({
      accessToken: getAccessToken()?.token,
      idTokens: [data.idToken]
    });

    resetUserProfile();

    closeCheckoutWindow?.();
  }
}
